/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var About = "About";
var Access = "Access";
var Account = "Account";
var Actions = "Actions";
var Active = "Active";
var Add = "Add";
var Address = "Address";
var Advanced = "Advanced";
var Aliases = "Aliases";
var all = "all";
var All = "All";
var Apply = "Apply";
var April = "April";
var Arbitrary = "Arbitrary";
var Assign = "Assign";
var August = "August";
var Back = "Back";
var Basic = "Basic";
var BNPP_EU = "BNPP_EU";
var Cancel = "Cancel";
var Category = "Category";
var Classic = "Classic";
var Clear = "Clear";
var CLI = "CLI";
var Close = "Close";
var Clusters = "Clusters";
var code = "code";
var Complete = "Complete";
var Completed = "Completed";
var Compliance = "Compliance";
var Compliant = "Compliant";
var Configuration = "Configuration";
var Configure = "Configure";
var Confirm = "Confirm";
var Connect = "Connect";
var Connected = "Connected";
var Connecting = "Connecting";
var Containers = "Containers";
var Country = "Country";
var Create = "Create";
var Created = "Created";
var Creating = "Creating";
var Critical = "Critical";
var Current = "Current";
var Custom = "Custom";
var Dallas = "Dallas";
var Datacenter = "Datacenter";
var Datacenters = "Datacenters";
var December = "December";
var Delete = "Delete";
var Deleting = "Deleting";
var Deploying = "Deploying";
var Disabled = "Disabled";
var Disconnect = "Disconnect";
var Docs = "Docs";
var Documentation = "Documentation";
var Done = "Done";
var Download = "Download";
var Draft = "Draft";
var Edit = "Edit";
var Enabled = "Enabled";
var Encryption = "Encryption";
var End = "End";
var Enterprise = "Enterprise";
var Establish = "Establish";
var Expired = "Expired";
var Failed = "Failed";
var February = "February";
var Filter = "Filter";
var Filters = "Filters";
var Finalizing = "Finalizing";
var Frankfurt = "Frankfurt";
var Free = "Free";
var Friday = "Friday";
var Geography = "Geography";
var Help = "Help";
var hour = "hour";
var Hour = "Hour";
var hr = "hr";
var IAM = "IAM";
var ID = "ID";
var Images = "Images";
var Inactive = "Inactive";
var Incomplete = "Incomplete";
var Information = "Information";
var Infrastructure = "Infrastructure";
var Instance = "Instance";
var Instances = "Instances";
var Integrations = "Integrations";
var Invalid = "Invalid";
var January = "January";
var July = "July";
var June = "June";
var Key = "Key";
var Launch = "Launch";
var Lite = "Lite";
var Loading = "Loading";
var Location = "Location";
var Locations = "Locations";
var Logging = "Logging";
var London = "London";
var March = "March";
var May = "May";
var Metro = "Metro";
var Minute = "Minute";
var mo = "mo";
var Monday = "Monday";
var Monitoring = "Monitoring";
var Month = "Month";
var more = "more";
var Name = "Name";
var Namespace = "Namespace";
var Namespaces = "Namespaces";
var Next = "Next";
var No = "No";
var None = "None";
var Normal = "Normal";
var Note = "Note";
var Notification = "Notification";
var November = "November";
var Objects = "Objects";
var October = "October";
var Off = "Off";
var OK = "OK";
var On = "On";
var Open = "Open";
var Osaka = "Osaka";
var Overview = "Overview";
var Packages = "Packages";
var Pattern = "Pattern";
var Pending = "Pending";
var Plan = "Plan";
var Premium = "Premium";
var Previous = "Previous";
var Product = "Product";
var Products = "Products";
var Project = "Project";
var Projects = "Projects";
var Property = "Property";
var provided = "provided";
var Provider = "Provider";
var Provisioning = "Provisioning";
var Ready = "Ready";
var Refresh = "Refresh";
var region = "region";
var Region = "Region";
var Remove = "Remove";
var Renew = "Renew";
var Repositories = "Repositories";
var Requested = "Requested";
var Required = "Required";
var Reservations = "Reservations";
var Reset = "Reset";
var resources = "resources";
var Resources = "Resources";
var Results = "Results";
var Review = "Review";
var Routing = "Routing";
var Satellite = "Satellite";
var Saturday = "Saturday";
var Save = "Save";
var Scanning = "Scanning";
var Schedule = "Schedule";
var Search = "Search";
var Secret = "Secret";
var Select = "Select";
var Sending = "Sending";
var September = "September";
var Serverless = "Serverless";
var Service = "Service";
var Settings = "Settings";
var Size = "Size";
var Sort = "Sort";
var Source = "Source";
var Start = "Start";
var State = "State";
var Status = "Status";
var Storage = "Storage";
var Submit = "Submit";
var Subscription = "Subscription";
var Success = "Success";
var Summary = "Summary";
var Sunday = "Sunday";
var Sydney = "Sydney";
var tag = "tag";
var tags = "tags";
var Tags = "Tags";
var Thursday = "Thursday";
var Tokyo = "Tokyo";
var Topics = "Topics";
var Toronto = "Toronto";
var Total = "Total";
var Trash = "Trash";
var Trial = "Trial";
var Tuesday = "Tuesday";
var Unknown = "Unknown";
var Unsupported = "Unsupported";
var Update = "Update";
var Upgrade = "Upgrade";
var Value = "Value";
var Values = "Values";
var Version = "Version";
var View = "View";
var Warning = "Warning";
var Wednesday = "Wednesday";
var Workloads = "Workloads";
var Yes = "Yes";
var Zone = "Zone";
var Zones = "Zones";
var en = {
	"'{{namespace}}' already exists. Enter another name.": "'{{namespace}}' already exists. Enter another name.",
	"'Day of week' matches in addition to 'Day of month'": "'Day of week' matches in addition to 'Day of month'",
	"'Day of week' matches in addition to 'Day of month'. The expression triggers every day.": "'Day of week' matches in addition to 'Day of month'. The expression triggers every day.",
	"(IAM)": "(IAM)",
	"{{count}} items selected": "{{count}} items selected",
	"{{count}} resources": "{{count}} resources",
	"{{count}} resources included": "{{count}} resources included",
	"{{current}} of {{total}} pages": "{{current}} of {{total}} pages",
	"{{datahookName}} response": "{{datahookName}} response",
	"{{instance_name}} ( {{region}} )": "{{instance_name}} ( {{region}} )",
	"{{label}} patterns": "{{label}} patterns",
	"{{min}}–{{max}} items": "{{min}}–{{max}} items",
	"{{min}}–{{max}} of {{total}} items": "{{min}}–{{max}} of {{total}} items",
	"{{moduleCount}} modules, {{resourcesCount}} resources": "{{moduleCount}} modules, {{resourcesCount}} resources",
	"{{name}} requires the following option(s) in order to deploy.": "{{name}} requires the following option(s) in order to deploy.",
	"{{price}} per {{unit}}": "{{price}} per {{unit}}",
	"{{price}} per month": "{{price}} per month",
	"{{price}}/{{unit}}": "{{price}}/{{unit}}",
	"{{price}}/mo": "{{price}}/mo",
	"{{resourcesCount}} resources": "{{resourcesCount}} resources",
	"{{rolesCount}} Role": "{{rolesCount}} Role",
	"{{rolesCount}} Roles": "{{rolesCount}} Roles",
	"{{topicsCount}} topic active for this instance.": "{{topicsCount}} topic active for this instance.",
	"{{topicsCount}} topics active for this instance.": "{{topicsCount}} topics active for this instance.",
	"{{value}} percent status progress": "{{value}} percent status progress",
	"{{version}} (create a new cluster to try out this beta version)": "{{version}} (create a new cluster to try out this beta version)",
	"{{version}} (update to an earlier version first)": "{{version}} (update to an earlier version first)",
	"<span>You must have a Cloud Object Storage instance to create a Satellite location.</span> <a>Learn more.</a>": "<span>You must have a Cloud Object Storage instance to create a Satellite location.</span> <a>Learn more.</a>",
	"$0.00": "$0.00",
	"$0.00 / instance": "$0.00 / instance",
	"1 item selected": "1 item selected",
	"1 of 1 page": "1 of 1 page",
	"1 role": "1 role",
	"1–1 of 1 item": "1–1 of 1 item",
	"A collection of keys that belong to your service instance.": "A collection of keys that belong to your service instance.",
	"A key can only have 5 aliases.": "A key can only have 5 aliases.",
	"A Key Protect key": "A Key Protect key",
	"A location name is required. ": "A location name is required. ",
	"A multi-tenant key management service. Create and manage cryptographic keys to encrypt data in your applications and control access to your data.": "A multi-tenant key management service. Create and manage cryptographic keys to encrypt data in your applications and control access to your data.",
	"A name is required.": "A name is required.",
	"A rotation policy of 12 months is recommended": "A rotation policy of 12 months is recommended",
	"A service to service authorization is required between {{sourceServiceDisplayName}} and {{serviceDisplayName}} to associate the encryption key. Key Protect will create one with your consent. Or you can create one manually.": "A service to service authorization is required between {{sourceServiceDisplayName}} and {{serviceDisplayName}} to associate the encryption key. Key Protect will create one with your consent. Or you can create one manually.",
	"A single-tenant key management service. Create and manage cryptographic keys with key vaulting that is provided by dedicated customer-controlled Hardware Security Module. ": "A single-tenant key management service. Create and manage cryptographic keys with key vaulting that is provided by dedicated customer-controlled Hardware Security Module. ",
	"A tag can include only alphanumeric characters, spaces, underscores, dashes, periods and one colon.": "A tag can include only alphanumeric characters, spaces, underscores, dashes, periods and one colon.",
	"A tag cannot end with a colon.": "A tag cannot end with a colon.",
	"A tag cannot include more than 128 characters.": "A tag cannot include more than 128 characters.",
	"A tag cannot start with a colon.": "A tag cannot start with a colon.",
	"A tag should not have spaces around a colon.": "A tag should not have spaces around a colon.",
	About: About,
	Access: Access,
	"Access management tags": "Access management tags",
	"Access management tags (optional)": "Access management tags (optional)",
	"Access management tags help you apply flexible access policies on specific resources.": "Access management tags help you apply flexible access policies on specific resources.",
	Account: Account,
	"Account type": "Account type",
	"Action required": "Action required",
	Actions: Actions,
	Active: Active,
	"Active promotions": "Active promotions",
	"Activity tracker event collection is enabled for this resource and sent to targets as defined by your routing configuration.": "Activity tracker event collection is enabled for this resource and sent to targets as defined by your routing configuration.",
	"Activity tracker events": "Activity tracker events",
	"Activity tracking": "Activity tracking",
	Add: Add,
	"Add a single namespace or multiple namespaces to your specific namespace's list.": "Add a single namespace or multiple namespaces to your specific namespace's list.",
	"Add a single project or multiple projects to your specific project's list.": "Add a single project or multiple projects to your specific project's list.",
	"Add Activity tracker event collection": "Add Activity tracker event collection",
	"Add activity tracking": "Add activity tracking",
	"Add event collection": "Add event collection",
	"Add hosts": "Add hosts",
	"Add hosts to meet the minimum service requirements.": "Add hosts to meet the minimum service requirements.",
	"Add key alias (optional)": "Add key alias (optional)",
	"Add key description (optional)": "Add key description (optional)",
	"Add logging": "Add logging",
	"Add monitoring": "Add monitoring",
	"Add namespace": "Add namespace",
	"Add New": "Add New",
	"Add project": "Add project",
	"Add storage": "Add storage",
	"Add tags": "Add tags",
	"Add to estimate": "Add to estimate",
	"Add to existing": "Add to existing",
	"Add to project": "Add to project",
	"Adding ...": "Adding ...",
	Address: Address,
	"Address any required actions below to successfully provision your service. You can complete these steps now, or after creating the service.": "Address any required actions below to successfully provision your service. You can complete these steps now, or after creating the service.",
	"Address field": "Address field",
	Advanced: Advanced,
	"Advanced options": "Advanced options",
	"After connection": "After connection",
	"After the service cluster is created, assign storage to the cluster.": "After the service cluster is created, assign storage to the cluster.",
	"After you disconnect Event Notifications, the {{serviceName}} instance is removed from the list of source services in the Event Notifications instance.": "After you disconnect Event Notifications, the {{serviceName}} instance is removed from the list of source services in the Event Notifications instance.",
	Aliases: Aliases,
	"Aliases may only contain alphanumeric characters and -_.": "Aliases may only contain alphanumeric characters and -_.",
	"Aliases must be at least 2 characters and at most 90 characters.": "Aliases must be at least 2 characters and at most 90 characters.",
	all: all,
	All: All,
	"All audit events (default target)": "All audit events (default target)",
	"All audit events from your account will be sent to a new instance": "All audit events from your account will be sent to a new instance",
	"All audit events from your account will be sent to an existing instance": "All audit events from your account will be sent to an existing instance",
	"All namespaces": "All namespaces",
	"All namespaces not supported": "All namespaces not supported",
	"All platform logs": "All platform logs",
	"All prerequisite services are installed on the location.": "All prerequisite services are installed on the location.",
	"All projects": "All projects",
	"All projects not supported": "All projects not supported",
	"All regions": "All regions",
	"All resource groups": "All resource groups",
	"All secret groups": "All secret groups",
	"All types": "All types",
	"All zone names must be unique": "All zone names must be unique",
	"Allowed actions for the {{roleName}} role ({{actionCount}})": "Allowed actions for the {{roleName}} role ({{actionCount}})",
	"Already have an account? <a>Log in</a>": "Already have an account? <a>Log in</a>",
	"An error occurred when fetching secrets. Try again later.": "An error occurred when fetching secrets. Try again later.",
	"An instance of Event Notifications <a>Create new instance</a>": "An instance of Event Notifications <a>Create new instance</a>",
	"An unexpected error occurred.": "An unexpected error occurred.",
	"Analyze and manage logs for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "Analyze and manage logs for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>",
	Apply: Apply,
	"Apply a code": "Apply a code",
	April: April,
	Arbitrary: Arbitrary,
	"Are you sure that you want to disconnect {{serviceName}} instance from the \"{{ENInstanceName}}\" instance?": "Are you sure that you want to disconnect {{serviceName}} instance from the \"{{ENInstanceName}}\" instance?",
	"Are you sure you want to close the side panel?": "Are you sure you want to close the side panel?",
	"Are you sure you want to close this panel? Any selections you have made will be lost.": "Are you sure you want to close this panel? Any selections you have made will be lost.",
	"Are you sure?": "Are you sure?",
	Assign: Assign,
	"Associate key": "Associate key",
	"Attachment name": "Attachment name",
	"Audit event collection is already enabled for this resource": "Audit event collection is already enabled for this resource",
	"Audit event collection is recommended for optimal troubleshooting and reducing downtime": "Audit event collection is recommended for optimal troubleshooting and reducing downtime",
	"Audit events (error)": "Audit events (error)",
	"Audit events from {{region}} will be sent to a new instance": "Audit events from {{region}} will be sent to a new instance",
	"Audit events from {{region}} will be sent to an existing instance": "Audit events from {{region}} will be sent to an existing instance",
	"Audit events in {{region}}": "Audit events in {{region}}",
	"Audit events will be collected from enabled IBM Cloud services according to the defined routing scope.": "Audit events will be collected from enabled IBM Cloud services according to the defined routing scope.",
	"Audit events...": "Audit events...",
	August: August,
	"Authentication is required or you do not have the correct permissions to perform this action.": "Authentication is required or you do not have the correct permissions to perform this action.",
	"Authorization error": "Authorization error",
	"Authorization met": "Authorization met",
	"Authorization needed": "Authorization needed",
	"Authorize now": "Authorize now",
	"Authorizing...": "Authorizing...",
	Back: Back,
	"Base URI": "Base URI",
	"Base64 encoded key material": "Base64 encoded key material",
	Basic: Basic,
	"Before you begin": "Before you begin",
	"Before your project can validate or deploy configurations, the Projects service needs to be authorized in this account to communicate with Schematics, Catalog Management, Secrets Manager, and Resource Controller. A user with the required access to those services can automatically grant authorizations by creating a project in this account, or they can create the service to service authorizations manually. This authorization is only required once.": "Before your project can validate or deploy configurations, the Projects service needs to be authorized in this account to communicate with Schematics, Catalog Management, Secrets Manager, and Resource Controller. A user with the required access to those services can automatically grant authorizations by creating a project in this account, or they can create the service to service authorizations manually. This authorization is only required once.",
	"Billing information": "Billing information",
	"Billing period": "Billing period",
	BNPP_EU: BNPP_EU,
	"Bucket name": "Bucket name",
	"By {{name}}": "By {{name}}",
	"By clicking Save, you are creating the following access:": "By clicking Save, you are creating the following access:",
	"Can't retrieve details": "Can't retrieve details",
	Cancel: Cancel,
	"Cannot list integrations!": "Cannot list integrations!",
	"Cannot view keys in this instance": "Cannot view keys in this instance",
	Category: Category,
	"Charges apply. <a>Learn more</a>": "Charges apply. <a>Learn more</a>",
	"Choose a cluster version": "Choose a cluster version",
	"Choose a key ring": "Choose a key ring",
	"Choose a resource group": "Choose a resource group",
	"Choose account...": "Choose account...",
	"Choose an existing HPCS instance.": "Choose an existing HPCS instance.",
	"Choose an existing Key Protect instance.": "Choose an existing Key Protect instance.",
	"Choose an instance": "Choose an instance",
	"Choose an option": "Choose an option",
	"Choose category...": "Choose category...",
	"Choose location": "Choose location",
	"Choose plan": "Choose plan",
	"Choose property...": "Choose property...",
	"Choose provider...": "Choose provider...",
	"Choose secret...": "Choose secret...",
	"Choose service instance...": "Choose service instance...",
	"Choose source name...": "Choose source name...",
	"Choose source...": "Choose source...",
	"Choose which IBM Cloud Monitoring instance will receive platform metrics from enabled service instances across IBM Cloud.": "Choose which IBM Cloud Monitoring instance will receive platform metrics from enabled service instances across IBM Cloud.",
	"Choose which IBM Log Analysis instance will receive platform logs from enabled service instances across IBM Cloud.": "Choose which IBM Log Analysis instance will receive platform logs from enabled service instances across IBM Cloud.",
	Classic: Classic,
	Clear: Clear,
	"Clear all": "Clear all",
	"Clear all selected items": "Clear all selected items",
	"Clear filters": "Clear filters",
	"Clear selected": "Clear selected",
	"Clear selected item": "Clear selected item",
	"Clear selection": "Clear selection",
	CLI: CLI,
	Close: Close,
	"Close menu": "Close menu",
	"Close page navigation menu": "Close page navigation menu",
	"Close Panel": "Close Panel",
	"Close Push Panel": "Close Push Panel",
	"Closing side panel": "Closing side panel",
	"Cloud Logs": "Cloud Logs",
	"Cloud Logs instance": "Cloud Logs instance",
	"Cloud Logs instance name": "Cloud Logs instance name",
	"Cloud Object Storage": "Cloud Object Storage",
	"Cloud Object Storage instance": "Cloud Object Storage instance",
	"Cluster \"{{name}}\" is being deleted.": "Cluster \"{{name}}\" is being deleted.",
	"Cluster management": "Cluster management",
	"Cluster version": "Cluster version",
	"Cluster version cannot be updated.": "Cluster version cannot be updated.",
	Clusters: Clusters,
	code: code,
	"Code sample": "Code sample",
	"Collapse all rows": "Collapse all rows",
	"Collapse group": "Collapse group",
	"Collapse row": "Collapse row",
	"Collapse summary": "Collapse summary",
	"Compact (24px)": "Compact (24px)",
	Complete: Complete,
	Completed: Completed,
	Compliance: Compliance,
	Compliant: Compliant,
	Configuration: Configuration,
	"Configuration details": "Configuration details",
	"Configuration name": "Configuration name",
	Configure: Configure,
	"Configure activity tracking": "Configure activity tracking",
	"Configure encryption": "Configure encryption",
	"Configure logging": "Configure logging",
	"Configure monitoring": "Configure monitoring",
	Confirm: Confirm,
	Connect: Connect,
	"Connect to Event Notifications": "Connect to Event Notifications",
	"Connect your {{serviceName}} instance to an existing Event Notifications instance.": "Connect your {{serviceName}} instance to an existing Event Notifications instance.",
	Connected: Connected,
	"Connected instance": "Connected instance",
	"Connected instance of Event Notifications does not exist. Contact your administrator.": "Connected instance of Event Notifications does not exist. Contact your administrator.",
	Connecting: Connecting,
	"Contact your account administrator to access a plan to provision Key Protect.": "Contact your account administrator to access a plan to provision Key Protect.",
	"Contact your account administrator to access a resource group to provision Key Protect.": "Contact your account administrator to access a resource group to provision Key Protect.",
	"Contact your administrator for access.": "Contact your administrator for access.",
	"Contact your administrator for additional assistance.": "Contact your administrator for additional assistance.",
	"Container registry": "Container registry",
	Containers: Containers,
	"Copied to clipboard": "Copied to clipboard",
	"Copy to clipboard": "Copy to clipboard",
	"Cost details": "Cost details",
	"costctr:124": "costctr:124",
	"Could not load pricing information. Refresh the page or try again later.": "Could not load pricing information. Refresh the page or try again later.",
	Country: Country,
	Create: Create,
	"Create a key": "Create a key",
	"Create a Logs routing target to support log management and analysis for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "Create a Logs routing target to support log management and analysis for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>",
	"Create a new instance to get started.": "Create a new instance to get started.",
	"Create a project": "Create a project",
	"Create a Satellite location to bring IBM Cloud anywhere. For more information, <a>see the documentation.</a>": "Create a Satellite location to bring IBM Cloud anywhere. For more information, <a>see the documentation.</a>",
	"Create an Activity tracker event routing target and route to support monitoring and auditing IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "Create an Activity tracker event routing target and route to support monitoring and auditing IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>",
	"Create an encryption key or import your own key.": "Create an encryption key or import your own key.",
	"Create cluster": "Create cluster",
	"Create failed": "Create failed",
	"Create instance": "Create instance",
	"Create location": "Create location",
	"Create new": "Create new",
	"Create new instance": "Create new instance",
	"Create new key": "Create new key",
	"Create new secret": "Create new secret",
	"Create reference": "Create reference",
	"Create resource": "Create resource",
	"Create Satellite location": "Create Satellite location",
	"Create secret": "Create secret",
	"Create services": "Create services",
	"Create Topics, Destinations and Subscriptions in Event Notifications to be notified of events that are generated by your {{serviceName}}": "Create Topics, Destinations and Subscriptions in Event Notifications to be notified of events that are generated by your {{serviceName}}",
	Created: Created,
	Creating: Creating,
	"Creating ...": "Creating ...",
	"Creating...": "Creating...",
	Critical: Critical,
	"CRON expression": "CRON expression",
	Current: Current,
	Custom: Custom,
	"Custom access": "Custom access",
	Dallas: Dallas,
	"dashlet.title": "dashlet.title",
	Datacenter: Datacenter,
	Datacenters: Datacenters,
	"Datahook argument block": "Datahook argument block",
	"Datahook Params": "Datahook Params",
	"Datahook response": "Datahook response",
	"Day of month": "Day of month",
	"Day of Month (UTC)": "Day of Month (UTC)",
	"Day of week": "Day of week",
	"Day of week (UTC)": "Day of week (UTC)",
	December: December,
	"Dedicated hosts": "Dedicated hosts",
	"Default target": "Default target",
	"Default title": "Default title",
	"Define project details": "Define project details",
	"Define the recurring timings of the events generated by this event. Select a predefined pattern and customize it to your needs. Schedules are specified in Coordinated Universal Time (UTC).": "Define the recurring timings of the events generated by this event. Select a predefined pattern and customize it to your needs. Schedules are specified in Coordinated Universal Time (UTC).",
	"Define the scope of audit events collected": "Define the scope of audit events collected",
	Delete: Delete,
	"Delete cluster": "Delete cluster",
	"Delete failed": "Delete failed",
	"Delete retry wait": "Delete retry wait",
	"Delete the persistent storage used by this cluster": "Delete the persistent storage used by this cluster",
	Deleting: Deleting,
	"Deleting...": "Deleting...",
	"Deploy failed": "Deploy failed",
	"Deploy retry wait": "Deploy retry wait",
	Deploying: Deploying,
	"Deployment ready": "Deployment ready",
	"Deprecated version, support will end {{when}}. Update the version to continue to receive support.": "Deprecated version, support will end {{when}}. Update the version to continue to receive support.",
	"Description (optional)": "Description (optional)",
	"Description of the source": "Description of the source",
	Disabled: Disabled,
	Disconnect: Disconnect,
	"Disconnect Event Notifications": "Disconnect Event Notifications",
	"DNS subdomain labels must be no more than {{maxLength}} characters.": "DNS subdomain labels must be no more than {{maxLength}} characters.",
	Docs: Docs,
	Documentation: Documentation,
	Done: Done,
	"Done editing": "Done editing",
	Download: Download,
	Draft: Draft,
	"During the update, your cluster master, worker nodes, apps, and resources continue to run. After the update is complete, you can update your worker node versions. For instructions and more information about differences across versions, <a>review the docs</a>.": "During the update, your cluster master, worker nodes, apps, and resources continue to run. After the update is complete, you can update your worker node versions. For instructions and more information about differences across versions, <a>review the docs</a>.",
	Edit: Edit,
	"Edit activity tracker integration": "Edit activity tracker integration",
	"Edit Array": "Edit Array",
	"Edit columns": "Edit columns",
	"Edit configuration": "Edit configuration",
	"Edit details": "Edit details",
	"Edit JSON": "Edit JSON",
	"Edit logging integration": "Edit logging integration",
	"Edit secure value": "Edit secure value",
	"Edit tags": "Edit tags",
	"Enable lifecycle notifications for your {{serviceName}} instance by connecting an Event Notifications service instance.": "Enable lifecycle notifications for your {{serviceName}} instance by connecting an Event Notifications service instance.",
	Enabled: Enabled,
	"Enables supervision, compliance, and audits the operations and risk to manage your IBM Cloud account.": "Enables supervision, compliance, and audits the operations and risk to manage your IBM Cloud account.",
	Encryption: Encryption,
	"Encryption key associated": "Encryption key associated",
	"Encryption options menu": "Encryption options menu",
	End: End,
	"End date": "End date",
	"Enhance your Schematics experience with integrations. Start adding integrations today by selecting from one of the options below.": "Enhance your Schematics experience with integrations. Start adding integrations today by selecting from one of the options below.",
	"Enter a name for the configuration of the deployable architecture.  For example: production-vpc": "Enter a name for the configuration of the deployable architecture.  For example: production-vpc",
	"Enter a password": "Enter a password",
	"Enter a valid CRN": "Enter a valid CRN",
	"Enter array values. Quotations are added to values after you save.": "Enter array values. Quotations are added to values after you save.",
	"Enter name and description": "Enter name and description",
	"Enter names for the host zones. For high availability, allocate your hosts across these three zones based on your infrastructure provider zones. <a>Why do I need zones?</a>": "Enter names for the host zones. For high availability, allocate your hosts across these three zones based on your infrastructure provider zones. <a>Why do I need zones?</a>",
	"Enter namespaces separated by a comma. After you click Add, the new namespaces are included in the list and automatically selected.": "Enter namespaces separated by a comma. After you click Add, the new namespaces are included in the list and automatically selected.",
	"Enter projects separated by a comma. After you click Add, the new projects are included in the list and automatically selected.": "Enter projects separated by a comma. After you click Add, the new projects are included in the list and automatically selected.",
	"Enter source name": "Enter source name",
	"Enter the exact name of an existing bucket in your Cloud Object Storage instance. If no name is provided, a new bucket is created for you.": "Enter the exact name of an existing bucket in your Cloud Object Storage instance. If no name is provided, a new bucket is created for you.",
	Enterprise: Enterprise,
	"Entire secret": "Entire secret",
	"Environment (optional)": "Environment (optional)",
	"Environments can contain properties that are shared across related configurations. Within the configuration, you can override any values that are provided by the environment. <a>Learn more</a>": "Environments can contain properties that are shared across related configurations. Within the configuration, you can override any values that are provided by the environment. <a>Learn more</a>",
	"Error": "Error",
	"Error checking existing services status": "Error checking existing services status",
	"Error checking host status": "Error checking host status",
	"Error checking storage status": "Error checking storage status",
	"Error fetching tags": "Error fetching tags",
	"Error icon": "Error icon",
	"Error loading accounts": "Error loading accounts",
	"Error loading categories": "Error loading categories",
	"Error loading groups": "Error loading groups",
	"Error loading instances": "Error loading instances",
	"Error loading keys": "Error loading keys",
	"Error loading pricing": "Error loading pricing",
	"Error loading properties": "Error loading properties",
	"Error loading providers": "Error loading providers",
	"Error loading regions": "Error loading regions",
	"Error loading resource groups": "Error loading resource groups",
	"Error loading S2S auth": "Error loading S2S auth",
	"Error loading secrets": "Error loading secrets",
	"Error loading source names": "Error loading source names",
	"Error loading sources": "Error loading sources",
	"Error loading types": "Error loading types",
	"Error validating this code. Please make sure you don't include any quotation marks in the promo code.": "Error validating this code. Please make sure you don't include any quotation marks in the promo code.",
	Establish: Establish,
	"Estimate costs": "Estimate costs",
	"Estimated cost per instance": "Estimated cost per instance",
	"Estimated starting cost": "Estimated starting cost",
	"Estimated total ({{count}} instances)": "Estimated total ({{count}} instances)",
	"Event Notifications": "Event Notifications",
	"Event Notifications instance": "Event Notifications instance",
	"Event Notifications service instance": "Event Notifications service instance",
	"Event Source Manager": "Event Source Manager",
	"Every 2 hours": "Every 2 hours",
	"Every 2 minutes": "Every 2 minutes",
	"Every 3 hours": "Every 3 hours",
	"Every 4 hours": "Every 4 hours",
	"Every 5 minutes": "Every 5 minutes",
	"Every 6 hours": "Every 6 hours",
	"Every 10 minutes": "Every 10 minutes",
	"Every 15 minutes": "Every 15 minutes",
	"Every day": "Every day",
	"Every fifth day": "Every fifth day",
	"Every fourth day": "Every fourth day",
	"Every fourth month": "Every fourth month",
	"Every hour": "Every hour",
	"Every minute": "Every minute",
	"Every month": "Every month",
	"Every second day": "Every second day",
	"Every second month": "Every second month",
	"Every sixth month": "Every sixth month",
	"Every third day": "Every third day",
	"Every third month": "Every third month",
	"Examples: access:dev, proj:version-1": "Examples: access:dev, proj:version-1",
	"Examples: env:dev, version-1": "Examples: env:dev, version-1",
	"Existing instance": "Existing instance",
	"Exiting encryption selection": "Exiting encryption selection",
	"Expand all rows": "Expand all rows",
	"Expand group": "Expand group",
	"Expand row": "Expand row",
	"Expand summary": "Expand summary",
	Expired: Expired,
	"Expired (beta)": "Expired (beta)",
	"Expires {{when}}": "Expires {{when}}",
	"Expires after beta": "Expires after beta",
	"Extra large (64px)": "Extra large (64px)",
	"Extra small (24px)": "Extra small (24px)",
	Failed: Failed,
	"Failed to check permission": "Failed to check permission",
	"Failed to create configuration": "Failed to create configuration",
	"Failed to create key": "Failed to create key",
	"Failed to create policy": "Failed to create policy",
	"Failed to create project": "Failed to create project",
	"Failed to fetch": "Failed to fetch",
	"Failed to fetch IBM Cloud Activity Tracker instances.": "Failed to fetch IBM Cloud Activity Tracker instances.",
	"Failed to fetch IBM Cloud Monitoring instances.": "Failed to fetch IBM Cloud Monitoring instances.",
	"Failed to fetch IBM Log Analysis instances.": "Failed to fetch IBM Log Analysis instances.",
	"failure state": "failure state",
	February: February,
	"Fetch data": "Fetch data",
	Filter: Filter,
	"Filter instance by region": "Filter instance by region",
	"Filter...": "Filter...",
	Filters: Filters,
	"Filters:": "Filters:",
	Finalizing: Finalizing,
	"Finalizing cluster...": "Finalizing cluster...",
	"Finalizing workers...": "Finalizing workers...",
	Frankfurt: Frankfurt,
	Free: Free,
	Friday: Friday,
	Geography: Geography,
	"Get operational visibility into your Cloud resources with IBM Cloud Activity Tracker.": "Get operational visibility into your Cloud resources with IBM Cloud Activity Tracker.",
	"Get operational visibility into your Cloud resources with IBM Cloud Monitoring.": "Get operational visibility into your Cloud resources with IBM Cloud Monitoring.",
	"Get operational visibility into your Cloud resources with IBM Log Analysis.": "Get operational visibility into your Cloud resources with IBM Log Analysis.",
	"Get started": "Get started",
	"Get started with Security and Compliance Center": "Get started with Security and Compliance Center",
	"Give your key an alias for easy retrieval later.": "Give your key an alias for easy retrieval later.",
	"Helm catalog": "Helm catalog",
	Help: Help,
	"Hide password": "Hide password",
	"Host usage\n(used / total)": "Host usage\n(used / total)",
	"Hosts needed": "Hosts needed",
	"Hosts requirements met": "Hosts requirements met",
	hour: hour,
	Hour: Hour,
	"Hour (UTC)": "Hour (UTC)",
	hr: hr,
	"Hyper Protect Crypto Services": "Hyper Protect Crypto Services",
	"I agree to use my token to create a service to service policy between source service {{sourceServiceDisplayName}} and target service {{serviceDisplayName}} on my behalf.": "I agree to use my token to create a service to service policy between source service {{sourceServiceDisplayName}} and target service {{serviceDisplayName}} on my behalf.",
	"I confirm that I want to stop receiving platform logs from {{instance}}": "I confirm that I want to stop receiving platform logs from {{instance}}",
	"I confirm that I want to stop receiving platform metrics from {{instance}}": "I confirm that I want to stop receiving platform metrics from {{instance}}",
	"IaaS ready": "IaaS ready",
	IAM: IAM,
	"IAM credentials": "IAM credentials",
	"IBM Cloud": "IBM Cloud",
	"IBM Cloud Activity Tracker": "IBM Cloud Activity Tracker",
	"IBM Cloud Monitoring": "IBM Cloud Monitoring",
	"IBM Cloud Satellite": "IBM Cloud Satellite",
	"IBM Log Analysis": "IBM Log Analysis",
	ID: ID,
	"ID: {{incidentId}}": "ID: {{incidentId}}",
	"If no key ring is assigned, key will be added to the default key ring.": "If no key ring is assigned, key will be added to the default key ring.",
	"If selected, the array will be saved as \"__NOT_SET__\" string.": "If selected, the array will be saved as \"__NOT_SET__\" string.",
	"If the initial value was not a valid string array, an empty or single item array will appear below.": "If the initial value was not a valid string array, an empty or single item array will appear below.",
	"If your user tags are billing related, consider writing tags as key:value pairs, such as": "If your user tags are billing related, consider writing tags as key:value pairs, such as",
	Images: Images,
	"Import your own key": "Import your own key",
	"In progress": "In progress",
	"in progress state": "in progress state",
	Inactive: Inactive,
	"inactive state": "inactive state",
	Incomplete: Incomplete,
	"incomplete state": "incomplete state",
	Information: Information,
	"information state": "information state",
	Infrastructure: Infrastructure,
	"Infrastructure zones": "Infrastructure zones",
	Instance: Instance,
	"Instance ID": "Instance ID",
	"Instance location": "Instance location",
	"Instance name": "Instance name",
	"Instance(s) in {{region}}": "Instance(s) in {{region}}",
	"Instance(s) in region": "Instance(s) in region",
	Instances: Instances,
	Integrations: Integrations,
	"Internal server error. Wait a minute and try your action again. If the issue persists, open a support ticket.": "Internal server error. Wait a minute and try your action again. If the issue persists, open a support ticket.",
	"Interpolated URI": "Interpolated URI",
	Invalid: Invalid,
	"Invalid datahook object, using last valid options": "Invalid datahook object, using last valid options",
	"Invalid label name.": "Invalid label name.",
	"Invalid label prefix or name.": "Invalid label prefix or name.",
	"Invalid label value.": "Invalid label value.",
	"Items per page:": "Items per page:",
	January: January,
	July: July,
	June: June,
	Key: Key,
	"Key aliases": "Key aliases",
	"Key CRN": "Key CRN",
	"Key description": "Key description",
	"Key description must be at least 2 characters and no more than 240 characters.": "Key description must be at least 2 characters and no more than 240 characters.",
	"Key ID": "Key ID",
	"Key management": "Key management",
	"Key management service": "Key management service",
	"Key material": "Key material",
	"Key material is required to import a key": "Key material is required to import a key",
	"Key material length must be 128, 192, or 256 bits": "Key material length must be 128, 192, or 256 bits",
	"Key material must be base64": "Key material must be base64",
	"Key name": "Key name",
	"Key Protect": "Key Protect",
	"Key Protect instance name": "Key Protect instance name",
	"Key ring": "Key ring",
	"Key value": "Key value",
	"Label must be of the form 'key:value'.": "Label must be of the form 'key:value'.",
	"Label name must be no more than {{maxLength}} characters.": "Label name must be no more than {{maxLength}} characters.",
	"Label prefix must be a valid DNS subdomain.": "Label prefix must be a valid DNS subdomain.",
	"Label prefix must be no more than {{maxLength}} characters.": "Label prefix must be no more than {{maxLength}} characters.",
	"Label value must be no more than {{maxLength}} characters.": "Label value must be no more than {{maxLength}} characters.",
	"Large (48px)": "Large (48px)",
	"Last modified": "Last modified",
	"Last scanned": "Last scanned",
	"Last updated": "Last updated",
	Launch: Launch,
	"Launch activiting tracking": "Launch activiting tracking",
	"Launch in new window": "Launch in new window",
	"Launch logging": "Launch logging",
	"Launch monitoring": "Launch monitoring",
	"Learn more": "Learn more",
	"learn more.": "learn more.",
	"Learn more.": "Learn more.",
	"List of actions": "List of actions",
	"list of code sample types": "list of code sample types",
	Lite: Lite,
	Loading: Loading,
	"Loading indicator": "Loading indicator",
	"Loading...": "Loading...",
	"Locate by CRN within your account": "Locate by CRN within your account",
	Location: Location,
	"Location summary": "Location summary",
	"Location:": "Location:",
	Locations: Locations,
	"Log collection is already enabled for this resource": "Log collection is already enabled for this resource",
	"Log collection is enabled for this resource and sent to targets as defined by your routing configuration.": "Log collection is enabled for this resource and sent to targets as defined by your routing configuration.",
	Logging: Logging,
	"Logging (error)": "Logging (error)",
	"Logging is recommended for optimal troubleshooting and reducing downtime": "Logging is recommended for optimal troubleshooting and reducing downtime",
	"Logging...": "Logging...",
	London: London,
	"Looking for valid service to service authorization policy...": "Looking for valid service to service authorization policy...",
	"Looks like you are missing the required permissions to create the policy. Contact your account administrator": "Looks like you are missing the required permissions to create the policy. Contact your account administrator",
	"Looks like you don't have access to view account information.": "Looks like you don't have access to view account information.",
	"Looks like you don't have access to view the billing period": "Looks like you don't have access to view the billing period",
	"Looks like you don't have any scans": "Looks like you don't have any scans",
	"Looks like you don't have the access needed to view this information. Contact your account administrator to verify your permissions.": "Looks like you don't have the access needed to view this information. Contact your account administrator to verify your permissions.",
	"Looks like you don't have the correct access": "Looks like you don't have the correct access",
	"Looks like you don't have the correct access. You must have access to the target service to create an authorization between services.": "Looks like you don't have the correct access. You must have access to the target service to create an authorization between services.",
	"Make sure you have Topics, Subscriptions and Destinations setup in Event Notifications.": "Make sure you have Topics, Subscriptions and Destinations setup in Event Notifications.",
	"Manage encryption by enabling a key management service (KMS).": "Manage encryption by enabling a key management service (KMS).",
	"Manage routing": "Manage routing",
	"Manage the lifecycle of your encryption keys that are used for you IBM Cloud resources, services, and applications.": "Manage the lifecycle of your encryption keys that are used for you IBM Cloud resources, services, and applications.",
	"Managed from": "Managed from",
	March: March,
	May: May,
	"Media gallery video": "Media gallery video",
	"Medium (40px)": "Medium (40px)",
	"Metadata location": "Metadata location",
	Metro: Metro,
	"Minimum host requirements are met.": "Minimum host requirements are met.",
	Minute: Minute,
	"Minute (UTC)": "Minute (UTC)",
	"Missing prerequisite services": "Missing prerequisite services",
	mo: mo,
	"Modify the arguments passed into your datahook here.": "Modify the arguments passed into your datahook here.",
	"Mon-Fri": "Mon-Fri",
	Monday: Monday,
	"Monitor all of your environments for compliance by setting up scans.": "Monitor all of your environments for compliance by setting up scans.",
	"Monitor and audit IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "Monitor and audit IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>",
	Monitoring: Monitoring,
	Month: Month,
	"Month (UTC)": "Month (UTC)",
	more: more,
	Name: Name,
	"Name already in use. Provide a unique name.": "Name already in use. Provide a unique name.",
	"Name must be between 2 and 90 characters": "Name must be between 2 and 90 characters",
	"Name this project": "Name this project",
	Namespace: Namespace,
	Namespaces: Namespaces,
	"New instance": "New instance",
	Next: Next,
	"Next page": "Next page",
	"Next: Customize": "Next: Customize",
	"nmpc-1, namespc-2": "nmpc-1, namespc-2",
	No: No,
	"No available catalog regions": "No available catalog regions",
	"No Cloud Object Storage instance is available.": "No Cloud Object Storage instance is available.",
	"No code preview has been configured for terraform. Please visit our docs to ": "No code preview has been configured for terraform. Please visit our docs to ",
	"No configurations available": "No configurations available",
	"No events can be scheduled with your selected CRON expression.": "No events can be scheduled with your selected CRON expression.",
	"No Hyper Protect Crypto Services instances found": "No Hyper Protect Crypto Services instances found",
	"No instances found": "No instances found",
	"No item matches the filters. Clear the filters and try again.": "No item matches the filters. Clear the filters and try again.",
	"No items available to display. Select an instance and bucket to view objects.": "No items available to display. Select an instance and bucket to view objects.",
	"No items match the current filter.": "No items match the current filter.",
	"No keys available": "No keys available",
	"No matches found. To create new tags, contact your tag administrator.": "No matches found. To create new tags, contact your tag administrator.",
	"No matching options": "No matching options",
	"No matching region ID's are available on this account. If you think this is an error, refresh the page or contact your administrator.": "No matching region ID's are available on this account. If you think this is an error, refresh the page or contact your administrator.",
	"No plans found": "No plans found",
	"No regions available": "No regions available",
	"No resource groups available": "No resource groups available",
	"No secret available": "No secret available",
	"No secret group available": "No secret group available",
	"No service instance available": "No service instance available",
	"No valid version update options are available.": "No valid version update options are available.",
	"Non-compliant": "Non-compliant",
	None: None,
	"None available": "None available",
	Normal: Normal,
	"Normal (48px)": "Normal (48px)",
	"Not authorized": "Not authorized",
	"Not ready": "Not ready",
	Note: Note,
	Notification: Notification,
	November: November,
	"Object": "Object",
	"Object storage": "Object storage",
	"Object storage is used to store data about your location and backups for your location's clusters. <a>Learn more.</a>": "Object storage is used to store data about your location and backups for your location's clusters. <a>Learn more.</a>",
	Objects: Objects,
	October: October,
	Off: Off,
	OK: OK,
	On: On,
	"Once a day": "Once a day",
	"Once a month": "Once a month",
	"Once a week": "Once a week",
	"Once a year": "Once a year",
	Open: Open,
	"Open dashboard": "Open dashboard",
	"Open Dashboard": "Open Dashboard",
	"Open menu": "Open menu",
	"Open page navigation menu": "Open page navigation menu",
	"Open reference picker": "Open reference picker",
	"Open tab list": "Open tab list",
	Osaka: Osaka,
	"Overflow menu": "Overflow menu",
	"Overflow Menu": "Overflow Menu",
	Overview: Overview,
	Packages: Packages,
	"page {{pageNumber}}": "page {{pageNumber}}",
	"Page Navigation": "Page Navigation",
	"Page navigation menu": "Page navigation menu",
	"Page number": "Page number",
	Pattern: Pattern,
	"Pay-As-You-Go": "Pay-As-You-Go",
	Pending: Pending,
	Plan: Plan,
	"Platform access": "Platform access",
	"Platform logs from {{region}} will be sent to a new instance": "Platform logs from {{region}} will be sent to a new instance",
	"Platform logs from {{region}} will be sent to an existing instance": "Platform logs from {{region}} will be sent to an existing instance",
	"Platform logs from {{region}} will be sent to the target instance. <a>Learn more</a>": "Platform logs from {{region}} will be sent to the target instance. <a>Learn more</a>",
	"Platform logs will be collected from enabled IBM Cloud services according to the defined routing scope.": "Platform logs will be collected from enabled IBM Cloud services according to the defined routing scope.",
	"Please <a>sign up</a> to create or <a>login</a> before applying the promo code.": "Please <a>sign up</a> to create or <a>login</a> before applying the promo code.",
	"Prefix filter": "Prefix filter",
	Premium: Premium,
	"Preparing master, workers...": "Preparing master, workers...",
	"Preparing master...": "Preparing master...",
	"Prerequisite services installed": "Prerequisite services installed",
	Previous: Previous,
	"Previous page": "Previous page",
	"Pricing Plans": "Pricing Plans",
	"prj-1, projct-2": "prj-1, projct-2",
	Product: Product,
	Products: Products,
	Project: Project,
	Projects: Projects,
	Property: Property,
	"Provide a more detailed description of the key. To protect your privacy, do not use personal data, such as your name or location, as a description. You cannot change this after key creation.": "Provide a more detailed description of the key. To protect your privacy, do not use personal data, such as your name or location, as a description. You cannot change this after key creation.",
	provided: provided,
	Provider: Provider,
	"Provides visibility of the performance and health of your IBM Cloud powered resources application.": "Provides visibility of the performance and health of your IBM Cloud powered resources application.",
	Provisioning: Provisioning,
	Ready: Ready,
	"Ready to apply?": "Ready to apply?",
	Refresh: Refresh,
	"Refresh Cloud Object Storage instances": "Refresh Cloud Object Storage instances",
	"Refresh data": "Refresh data",
	"Refresh secrets": "Refresh secrets",
	region: region,
	Region: Region,
	Remove: Remove,
	"Remove sort": "Remove sort",
	"Rendering modify hooks is not supported to prevent unexpected resource changes.": "Rendering modify hooks is not supported to prevent unexpected resource changes.",
	Renew: Renew,
	Repositories: Repositories,
	Requested: Requested,
	"Requesting creation...": "Requesting creation...",
	Required: Required,
	Reservations: Reservations,
	Reset: Reset,
	"Reset filters": "Reset filters",
	"Reset to default": "Reset to default",
	"Reset zoom": "Reset zoom",
	"Resource Configuration": "Resource Configuration",
	"Resource group": "Resource group",
	"Resource group:": "Resource group:",
	"Resource list": "Resource list",
	"Resource List": "Resource List",
	resources: resources,
	Resources: Resources,
	"Resources not included in cost": "Resources not included in cost",
	"Restricted access": "Restricted access",
	Results: Results,
	"Retrying delete": "Retrying delete",
	"Retrying deploy": "Retrying deploy",
	"Revert {{resetCount}} to default": "Revert {{resetCount}} to default",
	Review: Review,
	"Review access assignments to {{resourceDisplayName}}": "Review access assignments to {{resourceDisplayName}}",
	"Review settings in Event Notifications": "Review settings in Event Notifications",
	"Review the following access group policies to ensure you're assigning the right level of access.": "Review the following access group policies to ensure you're assigning the right level of access.",
	"Rotation interval": "Rotation interval",
	"Rotation policies determine the interval between automatic key rotations. An interval of one month, for example, means that a key will be rotated every 30 days. If the policy is already enabled, this means that an instance policy exists for this instance and if no other action is taken, the rotation interval shown will be applied to the key. If it is disabled, enable it to set a policy for this key.": "Rotation policies determine the interval between automatic key rotations. An interval of one month, for example, means that a key will be rotated every 30 days. If the policy is already enabled, this means that an instance policy exists for this instance and if no other action is taken, the rotation interval shown will be applied to the key. If it is disabled, enable it to set a policy for this key.",
	"Rotation policy": "Rotation policy",
	"Rotation policy disabled": "Rotation policy disabled",
	"Route name": "Route name",
	Routing: Routing,
	"Routing scope": "Routing scope",
	"Row height": "Row height",
	"Sample not yet available": "Sample not yet available",
	"Sao Paulo": "Sao Paulo",
	"Sat-Sun": "Sat-Sun",
	Satellite: Satellite,
	"Satellite container": "Satellite container",
	"Satellite location": "Satellite location",
	"Satellite location base cost": "Satellite location base cost",
	"Satellite location base functionality": "Satellite location base functionality",
	Saturday: Saturday,
	Save: Save,
	"Saving...": "Saving...",
	Scanning: Scanning,
	Schedule: Schedule,
	"Schematics workspaces and other project data are stored in the selected region and resource group. <a>Learn more.</a>": "Schematics workspaces and other project data are stored in the selected region and resource group. <a>Learn more.</a>",
	"Schematics workspaces are provisioned in this region. Your project can still deploy resources to any region.": "Schematics workspaces are provisioned in this region. Your project can still deploy resources to any region.",
	"Schematics workspaces are provisioned in this resource group. Your project can still deploy resources to any resource group.": "Schematics workspaces are provisioned in this resource group. Your project can still deploy resources to any resource group.",
	Search: Search,
	"Search in this instance": "Search in this instance",
	Secret: Secret,
	"Secret configured": "Secret configured",
	"Secret group": "Secret group",
	"Secret type": "Secret type",
	"Secrets Manager": "Secrets Manager",
	"Secure value": "Secure value",
	"See details": "See details",
	Select: Select,
	"Select a location to see what steps you need to take next.": "Select a location to see what steps you need to take next.",
	"Select a project": "Select a project",
	"Select a reference": "Select a reference",
	"Select a region": "Select a region",
	"Select a resource group": "Select a resource group",
	"Select a role to determine the level of access for the source service.": "Select a role to determine the level of access for the source service.",
	"Select a secret": "Select a secret",
	"Select a secret group": "Select a secret group",
	"Select a service instance": "Select a service instance",
	"Select all {{totalRowCount}} items": "Select all {{totalRowCount}} items",
	"Select all rows on page": "Select all rows on page",
	"Select an environment": "Select an environment",
	"Select an existing configuration": "Select an existing configuration",
	"Select an IBM Cloud Monitoring instance to receive platform metrics": "Select an IBM Cloud Monitoring instance to receive platform metrics",
	"Select an IBM Log Analysis instance to receive platform logs": "Select an IBM Log Analysis instance to receive platform logs",
	"Select an instance": "Select an instance",
	"Select an instance to show keys": "Select an instance to show keys",
	"Select an option...": "Select an option...",
	"Select existing key": "Select existing key",
	"Select from Secrets Manager": "Select from Secrets Manager",
	"Select KMS instance": "Select KMS instance",
	"Select namespaces": "Select namespaces",
	"Select one or more namespaces": "Select one or more namespaces",
	"Select one or more projects": "Select one or more projects",
	"Select prerequisites": "Select prerequisites",
	"Select projects": "Select projects",
	"Select region and resource group": "Select region and resource group",
	"Select row": "Select row",
	"Select the <a>IBM Cloud region</a> that is closest to where your infrastructure resides to ensure low network latency.": "Select the <a>IBM Cloud region</a> that is closest to where your infrastructure resides to ensure low network latency.",
	"Select the following tile to deploy it.": "Select the following tile to deploy it.",
	"Send all audit events from enabled resources in {{region}}.": "Send all audit events from enabled resources in {{region}}.",
	"Send all available audit events in this account.": "Send all available audit events in this account.",
	"Send events to": "Send events to",
	"Send logs to": "Send logs to",
	"Send test notification": "Send test notification",
	Sending: Sending,
	"Sent!": "Sent!",
	September: September,
	Serverless: Serverless,
	"Serverless projects": "Serverless projects",
	Service: Service,
	"Service access": "Service access",
	"Service authorization": "Service authorization",
	"Service authorization is required to allow Activity Tracker Event Routing to communicate with Cloud Logs. Click <span>Authorize now</span> to create a policy scoped to all Cloud Logs resources in this account.": "Service authorization is required to allow Activity Tracker Event Routing to communicate with Cloud Logs. Click <span>Authorize now</span> to create a policy scoped to all Cloud Logs resources in this account.",
	"Service authorization required": "Service authorization required",
	"Service instance": "Service instance",
	"Service name": "Service name",
	"Service to service authorization must be provided for your instance. <a>Learn more</a>": "Service to service authorization must be provided for your instance. <a>Learn more</a>",
	"Service to service authorization policy found": "Service to service authorization policy found",
	"Service to service authorization policy needed": "Service to service authorization policy needed",
	"Service type": "Service type",
	"Service-to-service authorization couldn't be verified. Manually add and check the required roles.": "Service-to-service authorization couldn't be verified. Manually add and check the required roles.",
	"Service-to-service authorization requirements are met.": "Service-to-service authorization requirements are met.",
	"Set an interval (in months)": "Set an interval (in months)",
	"Set key rotation policy": "Set key rotation policy",
	"Set up auth": "Set up auth",
	Settings: Settings,
	"Short (32px)": "Short (32px)",
	"Show all filters": "Show all filters",
	"Show code sample": "Show code sample",
	"Show environments information": "Show environments information",
	"Show error information": "Show error information",
	"Show information": "Show information",
	"Show less": "Show less",
	"Show more": "Show more",
	"Show more details": "Show more details",
	"Show password": "Show password",
	"Show tooltip": "Show tooltip",
	"Showing {{count}} item": "Showing {{count}} item",
	"Showing {{count}} items": "Showing {{count}} items",
	Size: Size,
	"Small (32px)": "Small (32px)",
	"Some events from {{serviceName}}:": "Some events from {{serviceName}}:",
	"Something went wrong": "Something went wrong",
	"Something went wrong.": "Something went wrong.",
	"Something went wrong. Try reloading the page to see this information": "Something went wrong. Try reloading the page to see this information",
	Sort: Sort,
	"Sort ascending": "Sort ascending",
	"Sort descending": "Sort descending",
	Source: Source,
	"Source Details": "Source Details",
	"Source for the service does not exist in Event Notifications instance. Contact your administrator.": "Source for the service does not exist in Event Notifications instance. Contact your administrator.",
	"Source service": "Source service",
	"Specific namespaces not supported": "Specific namespaces not supported",
	"Specific projects not supported": "Specific projects not supported",
	Start: Start,
	"Start by creating a cluster that is just right to run your workloads.": "Start by creating a cluster that is just right to run your workloads.",
	"Start date": "Start date",
	"Starting at": "Starting at",
	"Starting costs are based on this resource configuration. You can edit configurations after you add this product to a project, which might impact costs.": "Starting costs are based on this resource configuration. You can edit configurations after you add this product to a project, which might impact costs.",
	State: State,
	Status: Status,
	"status icon": "status icon",
	"Stay in pattern": "Stay in pattern",
	"Steps complete": "Steps complete",
	Storage: Storage,
	"Storage bucket (optional)": "Storage bucket (optional)",
	"Storage configuration missing": "Storage configuration missing",
	"Storage ready": "Storage ready",
	"Store, search, analyze, monitor, and alert on your IBM Cloud logging data and events.": "Store, search, analyze, monitor, and alert on your IBM Cloud logging data and events.",
	Submit: Submit,
	Subscription: Subscription,
	Success: Success,
	"success state": "success state",
	"Success! This promotion was applied to your account.": "Success! This promotion was applied to your account.",
	"Successfully created new Key Protect instance": "Successfully created new Key Protect instance",
	Summary: Summary,
	Sunday: Sunday,
	"Support Plan": "Support Plan",
	"Switch to folders view": "Switch to folders view",
	"Switch to objects view": "Switch to objects view",
	Sydney: Sydney,
	"Syntax: ": "Syntax: ",
	tag: tag,
	"Tag '{{tagName}}' could not be created as the name is invalid.": "Tag '{{tagName}}' could not be created as the name is invalid.",
	tags: tags,
	Tags: Tags,
	"Tags:": "Tags:",
	"Tags: (optional)": "Tags: (optional)",
	"Tall (64px)": "Tall (64px)",
	"Target destination": "Target destination",
	"Target location": "Target location",
	"Target name": "Target name",
	"Target selected": "Target selected",
	"Target service instance": "Target service instance",
	"Target type": "Target type",
	"Template error": "Template error",
	"Terms and conditions": "Terms and conditions",
	"Test notification": "Test notification",
	"The address field is required.": "The address field is required.",
	"The catalog window might have been blocked from opening.": "The catalog window might have been blocked from opening.",
	"The connected Event Notifications instance was deleted from the account. To continue using notifications, disconnect the current instance by clicking Disconnect from the menu ( ⋮ ). Then, connect another Event Notifications instance.": "The connected Event Notifications instance was deleted from the account. To continue using notifications, disconnect the current instance by clicking Disconnect from the menu ( ⋮ ). Then, connect another Event Notifications instance.",
	"The description should not contain any leading or trailing whitespace characters.": "The description should not contain any leading or trailing whitespace characters.",
	"The description should not exceed {{limit}} characters in length.": "The description should not exceed {{limit}} characters in length.",
	"The following access is required:": "The following access is required:",
	"The following code preview displays the corresponding request as CLI commands. Use it as a starting point for writing your own automation. ": "The following code preview displays the corresponding request as CLI commands. Use it as a starting point for writing your own automation. ",
	"The following code preview displays the corresponding request as REST API calls. Use it as a starting point for writing your own automation. ": "The following code preview displays the corresponding request as REST API calls. Use it as a starting point for writing your own automation. ",
	"The following code preview displays the corresponding request with Terraform. Use it as a starting point for writing your own automation. ": "The following code preview displays the corresponding request with Terraform. Use it as a starting point for writing your own automation. ",
	"The following preview displays the corresponding request as code. Use it as a starting point for writing your own automation.": "The following preview displays the corresponding request as code. Use it as a starting point for writing your own automation.",
	"The following resources were not included in the cost estimate but might have an associated cost.": "The following resources were not included in the cost estimate but might have an associated cost.",
	"The IAM role manager for {{serviceName}}": "The IAM role manager for {{serviceName}}",
	"The instance can't be accessed because a service to service authorization was removed from the account. Create an authorization with Event Source Manager access between {{sourceServiceName}} and Event Notifications.": "The instance can't be accessed because a service to service authorization was removed from the account. Create an authorization with Event Source Manager access between {{sourceServiceName}} and Event Notifications.",
	"The list of namespaces can't be populated. Try again later.": "The list of namespaces can't be populated. Try again later.",
	"The list of projects can't be populated. Try again later.": "The list of projects can't be populated. Try again later.",
	"The name is required.": "The name is required.",
	"The name must be {{max}} or fewer characters, begin with a letter, and contain only alphanumeric characters, '-', and '.'": "The name must be {{max}} or fewer characters, begin with a letter, and contain only alphanumeric characters, '-', and '.'",
	"The name of a namespace can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "The name of a namespace can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.",
	"The name of a project can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "The name of a project can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.",
	"The name should contain only alphanumeric, underscore, dashes and space.": "The name should contain only alphanumeric, underscore, dashes and space.",
	"The name should not contain any special characters.": "The name should not contain any special characters.",
	"The name should not exceed {{limit}} characters in length.": "The name should not exceed {{limit}} characters in length.",
	"The region is required.": "The region is required.",
	"The resource group is required.": "The resource group is required.",
	"The resource group window might have been blocked from opening.": "The resource group window might have been blocked from opening.",
	"The tag name must be in a key:value format": "The tag name must be in a key:value format",
	"The tag name must be in a key:value format.": "The tag name must be in a key:value format.",
	"The window might have been blocked from opening.": "The window might have been blocked from opening.",
	"There was a problem loading resource groups.": "There was a problem loading resource groups.",
	"These roles allow access for using the service and performing service API calls. Each role is customized by the selected service. Select all that apply. Refer to the service's documentation for more details.": "These roles allow access for using the service and performing service API calls. Each role is customized by the selected service. Select all that apply. Refer to the service's documentation for more details.",
	"These roles are created by administrators in the account to customize how access is assigned to the service. Click the Actions for role icon to review what actions are mapped to this role.": "These roles are created by administrators in the account to customize how access is assigned to the service. Click the Actions for role icon to review what actions are mapped to this role.",
	"These roles enable actions to be performed on platform resources, such as creating an instance, connecting instances to apps, and assigning user access. Select all that apply.": "These roles enable actions to be performed on platform resources, such as creating an instance, connecting instances to apps, and assigning user access. Select all that apply.",
	"This field is required": "This field is required",
	"This is currently not being sent on submit and is pending an update from the team responsible for the API.": "This is currently not being sent on submit and is pending an update from the team responsible for the API.",
	"This is how your {{serviceName}} instance is referenced in Event Notifications": "This is how your {{serviceName}} instance is referenced in Event Notifications",
	"This project name \"{{name}}\" already exists, please choose another name.": "This project name \"{{name}}\" already exists, please choose another name.",
	"This section is under construction, come back later.": "This section is under construction, come back later.",
	"This service requires additional storage assigned to the cluster. No matching storage configuration exists.": "This service requires additional storage assigned to the cluster. No matching storage configuration exists.",
	"This tag already exists. Choose another name for your tag.": "This tag already exists. Choose another name for your tag.",
	"This value already exists.": "This value already exists.",
	"This view is not available for some account types": "This view is not available for some account types",
	"Three zone names are required": "Three zone names are required",
	Thursday: Thursday,
	"To add HPCS encryption, follow these steps:": "To add HPCS encryption, follow these steps:",
	"To connect, the instance in this region must be configured for platform": "To connect, the instance in this region must be configured for platform",
	"To control the notifications of the events generated by {{serviceName}}, connect to an Event Notifications instance. <a>Learn more</a>": "To control the notifications of the events generated by {{serviceName}}, connect to an Event Notifications instance. <a>Learn more</a>",
	"To create a new HPCS key, follow the steps below...": "To create a new HPCS key, follow the steps below...",
	Tokyo: Tokyo,
	Topics: Topics,
	Toronto: Toronto,
	Total: Total,
	"Total accounts": "Total accounts",
	"Total estimated cost": "Total estimated cost",
	"Transaction ID": "Transaction ID",
	Trash: Trash,
	Trial: Trial,
	"Try again later, or contact your account administrator.": "Try again later, or contact your account administrator.",
	"Try again later.": "Try again later.",
	"Try refreshing the page and then performing the action again to see if the problem persists. If so, make sure you're using a <a>supported browser</a> and check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "Try refreshing the page and then performing the action again to see if the problem persists. If so, make sure you're using a <a>supported browser</a> and check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.",
	"Try waiting a few minutes and perform the action again to see if the problem persists. If so, check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "Try waiting a few minutes and perform the action again to see if the problem persists. If so, check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.",
	Tuesday: Tuesday,
	"Type \"{{clusterName}}\" to confirm": "Type \"{{clusterName}}\" to confirm",
	"Type \"{{name}}\" to confirm": "Type \"{{name}}\" to confirm",
	"Unable to configure activity tracker event routing.": "Unable to configure activity tracker event routing.",
	"Unable to configure Activity Tracker integration.": "Unable to configure Activity Tracker integration.",
	"Unable to configure Logging integration.": "Unable to configure Logging integration.",
	"Unable to configure logging.": "Unable to configure logging.",
	"Unable to connect your service to Event Notifications service. Try again later.": "Unable to connect your service to Event Notifications service. Try again later.",
	"Unable to create authorization policy.": "Unable to create authorization policy.",
	"Unable to create Satellite location": "Unable to create Satellite location",
	"Unable to create the service to service policy at this time. Refresh the page, or try again later.": "Unable to create the service to service policy at this time. Refresh the page, or try again later.",
	"Unable to delete cluster": "Unable to delete cluster",
	"Unable to disconnect Event Notifications instance. Refresh the page, or try again later.": "Unable to disconnect Event Notifications instance. Refresh the page, or try again later.",
	"Unable to get cluster data": "Unable to get cluster data",
	"Unable to get Event Notifications instance details. Refresh the page, or try again later.": "Unable to get Event Notifications instance details. Refresh the page, or try again later.",
	"Unable to get storage instances.": "Unable to get storage instances.",
	"Unable to list clusters.": "Unable to list clusters.",
	"Unable to list locations.": "Unable to list locations.",
	"Unable to load Activity Tracker service catalog data": "Unable to load Activity Tracker service catalog data",
	"Unable to load Cloud Logs service catalog data": "Unable to load Cloud Logs service catalog data",
	"Unable to load cluster details.": "Unable to load cluster details.",
	"Unable to load cluster update version options.": "Unable to load cluster update version options.",
	"Unable to load event routing settings": "Unable to load event routing settings",
	"Unable to load event routing target instances": "Unable to load event routing target instances",
	"Unable to load event routing target instances.": "Unable to load event routing target instances.",
	"Unable to load event routing targets": "Unable to load event routing targets",
	"Unable to load event routing targets.": "Unable to load event routing targets.",
	"Unable to load IBM Cloud locations data": "Unable to load IBM Cloud locations data",
	"Unable to load logging instances": "Unable to load logging instances",
	"Unable to load logging instances.": "Unable to load logging instances.",
	"Unable to load logging service catalog data": "Unable to load logging service catalog data",
	"Unable to load logs routing targets": "Unable to load logs routing targets",
	"Unable to load logs routing targets.": "Unable to load logs routing targets.",
	"Unable to perform": "Unable to perform",
	"Unable to retrieve cluster details": "Unable to retrieve cluster details",
	"Unable to retrieve data": "Unable to retrieve data",
	"Unable to retrieve location information.": "Unable to retrieve location information.",
	"Unable to retrieve project configurations.": "Unable to retrieve project configurations.",
	"Unable to send test notification to Event Notifications instance. Try again later.": "Unable to send test notification to Event Notifications instance. Try again later.",
	"Unable to send the test notification to Event Notifications instance. Check if Topics are setup in Event Notifications.": "Unable to send the test notification to Event Notifications instance. Check if Topics are setup in Event Notifications.",
	"Unable to update cluster version.": "Unable to update cluster version.",
	Unknown: Unknown,
	"unknown state": "unknown state",
	"Unselect all rows": "Unselect all rows",
	"Unselect row": "Unselect row",
	Unsupported: Unsupported,
	"Unsupported version. Update the version to continue to receive support.": "Unsupported version. Update the version to continue to receive support.",
	"Upcoming scheduled events in your timezone": "Upcoming scheduled events in your timezone",
	Update: Update,
	"Update available": "Update available",
	"Update cluster version": "Update cluster version",
	"Update tags": "Update tags",
	"Update version": "Update version",
	"Updating...": "Updating...",
	Upgrade: Upgrade,
	"Upgrade your account to view the billing period.": "Upgrade your account to view the billing period.",
	"Usage based charges apply per gigabyte of audit events ingested.": "Usage based charges apply per gigabyte of audit events ingested.",
	"Usage based charges apply per gigabyte of logs ingested.": "Usage based charges apply per gigabyte of logs ingested.",
	"Usage costs": "Usage costs",
	"Use a secret to securely and centrally manage your credentials for authentication. <a>Learn more</a>": "Use a secret to securely and centrally manage your credentials for authentication. <a>Learn more</a>",
	"Use a secret?": "Use a secret?",
	"Use existing": "Use existing",
	"Use key aliases to easily identify your keys. A key alias is a unique and easily recognizable custom name.": "Use key aliases to easily identify your keys. A key alias is a unique and easily recognizable custom name.",
	"Use tags to organize your resources. If your user tags are billing related, consider writing tags as key:value pairs to help group related tags, such as": "Use tags to organize your resources. If your user tags are billing related, consider writing tags as key:value pairs to help group related tags, such as",
	"Use the options below to choose the item that the reference will be created for.": "Use the options below to choose the item that the reference will be created for.",
	"User evaluation required": "User evaluation required",
	"User permissions failure": "User permissions failure",
	"User tags": "User tags",
	"User tags (optional": "User tags (optional",
	"User tags are visible account-wide. Avoid including sensitive data in the tag name.": "User tags are visible account-wide. Avoid including sensitive data in the tag name.",
	Value: Value,
	"Value must be a valid array (Ex. [\"array\"]). To specify a null array use \"__NOT_SET__\"": "Value must be a valid array (Ex. [\"array\"]). To specify a null array use \"__NOT_SET__\"",
	Values: Values,
	"Verify that the following services have been installed on the location: {{missingServices}}.": "Verify that the following services have been installed on the location: {{missingServices}}.",
	Version: Version,
	View: View,
	"View all": "View all",
	"View audit events": "View audit events",
	"View docs": "View docs",
	"View error information": "View error information",
	"View logging": "View logging",
	"View-only mode": "View-only mode",
	"VPC Gen1": "VPC Gen1",
	"VPC Gen2": "VPC Gen2",
	Warning: Warning,
	"warning state": "warning state",
	"Washington DC": "Washington DC",
	Wednesday: Wednesday,
	"What you will need:": "What you will need:",
	"What's the purpose of this project?": "What's the purpose of this project?",
	"When you delete the cluster, all worker nodes, apps, and containers are permanently deleted. This action cannot be undone. Before you proceed, make sure to back up all required data and configuration files.": "When you delete the cluster, all worker nodes, apps, and containers are permanently deleted. This action cannot be undone. Before you proceed, make sure to back up all required data and configuration files.",
	"Worker count": "Worker count",
	Workloads: Workloads,
	"Wrong Syntax": "Wrong Syntax",
	Yes: Yes,
	"You already have a location with this name. Enter a unique name.": "You already have a location with this name. Enter a unique name.",
	"You already have an instance of Security and Compliance Center. To see results, you must schedule your first scan by creating an attachment.": "You already have an instance of Security and Compliance Center. To see results, you must schedule your first scan by creating an attachment.",
	"You are unable to modify this policy due to your level of access for the policy's resource. If you'd like the ability to modify, contact your administrator to update your resource access.": "You are unable to modify this policy due to your level of access for the policy's resource. If you'd like the ability to modify, contact your administrator to update your resource access.",
	"You can find a list of resources here once you create them.": "You can find a list of resources here once you create them.",
	"You can find your resource details here after you create them.": "You can find your resource details here after you create them.",
	"You can find your resources here after you create them.": "You can find your resources here after you create them.",
	"You can find your Satellite locations here after you create them.": "You can find your Satellite locations here after you create them.",
	"You do not have access to any resource groups.": "You do not have access to any resource groups.",
	"You do not have access to any resource groups. <a>Create</a> a resource group.": "You do not have access to any resource groups. <a>Create</a> a resource group.",
	"You do not have permission to edit tags. Contact your administrator if you require greater access.": "You do not have permission to edit tags. Contact your administrator if you require greater access.",
	"You don't have the correct access to add a configuration in \"{{project}}\"": "You don't have the correct access to add a configuration in \"{{project}}\"",
	"You have restricted access and may not be able to add or remove tags. Contact your administrator if you require greater access.": "You have restricted access and may not be able to add or remove tags. Contact your administrator if you require greater access.",
	"You haven't connected an Event Notifications service instance yet.": "You haven't connected an Event Notifications service instance yet.",
	"You may also <a>create an instance</a>.": "You may also <a>create an instance</a>.",
	"You may also create a new one.": "You may also create a new one.",
	"You may have context-based restrictions or IAM policies enabled. Contact your account administrator.": "You may have context-based restrictions or IAM policies enabled. Contact your account administrator.",
	"You must have at least one active root key. Try creating a new one.": "You must have at least one active root key. Try creating a new one.",
	"You need at least 1 topic to send a test notification.": "You need at least 1 topic to send a test notification.",
	"You need the Editor or Administrator role on the IBM Cloud Projects service to this project. <a>Assign yourself access</a> or request access from your account administrator.": "You need the Editor or Administrator role on the IBM Cloud Projects service to this project. <a>Assign yourself access</a> or request access from your account administrator.",
	"You're adding tags to:": "You're adding tags to:",
	"You're editing tags for:": "You're editing tags for:",
	"You're not authorized to connect to this instance. Verify your permissions or contact your administrator.": "You're not authorized to connect to this instance. Verify your permissions or contact your administrator.",
	"You're using the newest version of the API server. There are no updates available at this time.": "You're using the newest version of the API server. There are no updates available at this time.",
	"You've reached the maximum number of tags that you can attach at a single time. To attach more tags, save your changes first.": "You've reached the maximum number of tags that you can attach at a single time. To attach more tags, save your changes first.",
	"Your API server is updating to version {{version}}. After it finishes you can update your worker nodes to the same version.": "Your API server is updating to version {{version}}. After it finishes you can update your worker nodes to the same version.",
	Zone: Zone,
	Zones: Zones,
	"Zoom in image": "Zoom in image",
	"Zoom out image": "Zoom out image"
};

export { About, Access, Account, Actions, Active, Add, Address, Advanced, Aliases, All, Apply, April, Arbitrary, Assign, August, BNPP_EU, Back, Basic, CLI, Cancel, Category, Classic, Clear, Close, Clusters, Complete, Completed, Compliance, Compliant, Configuration, Configure, Confirm, Connect, Connected, Connecting, Containers, Country, Create, Created, Creating, Critical, Current, Custom, Dallas, Datacenter, Datacenters, December, Delete, Deleting, Deploying, Disabled, Disconnect, Docs, Documentation, Done, Download, Draft, Edit, Enabled, Encryption, End, Enterprise, Establish, Expired, Failed, February, Filter, Filters, Finalizing, Frankfurt, Free, Friday, Geography, Help, Hour, IAM, ID, Images, Inactive, Incomplete, Information, Infrastructure, Instance, Instances, Integrations, Invalid, January, July, June, Key, Launch, Lite, Loading, Location, Locations, Logging, London, March, May, Metro, Minute, Monday, Monitoring, Month, Name, Namespace, Namespaces, Next, No, None, Normal, Note, Notification, November, OK, Objects, October, Off, On, Open, Osaka, Overview, Packages, Pattern, Pending, Plan, Premium, Previous, Product, Products, Project, Projects, Property, Provider, Provisioning, Ready, Refresh, Region, Remove, Renew, Repositories, Requested, Required, Reservations, Reset, Resources, Results, Review, Routing, Satellite, Saturday, Save, Scanning, Schedule, Search, Secret, Select, Sending, September, Serverless, Service, Settings, Size, Sort, Source, Start, State, Status, Storage, Submit, Subscription, Success, Summary, Sunday, Sydney, Tags, Thursday, Tokyo, Topics, Toronto, Total, Trash, Trial, Tuesday, Unknown, Unsupported, Update, Upgrade, Value, Values, Version, View, Warning, Wednesday, Workloads, Yes, Zone, Zones, all, code, en as default, hour, hr, mo, more, provided, region, resources, tag, tags };
